import React, { useEffect, useCallback, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import {
    ZoomOverlay,
    ZoomContainer,
    ZoomControls,
    ZoomButton,
    CloseButton,
    ZoomImage,
    ZoomInstructions
} from './ImageZoom.styled';

const ImageZoom = ({ src, alt, onClose }) => {
    const modalRoot = document.getElementById('modal-root');
    const transformRef = useRef(null);
    const [imageLoaded, setImageLoaded] = useState(false);

    // Cuando la imagen carga, centrar la vista
    const handleImageLoad = useCallback(() => {
        setImageLoaded(true);
        // Centrar después de que la imagen cargue
        setTimeout(() => {
            if (transformRef.current) {
                transformRef.current.centerView();
            }
        }, 10);
    }, []);

    const handleKeyDown = useCallback((e) => {
        if (e.key === 'Escape') {
            onClose();
        }
    }, [onClose]);

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);
        document.body.style.overflow = 'hidden';

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            document.body.style.overflow = 'unset';
        };
    }, [handleKeyDown]);

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    const zoomContent = (
        <ZoomOverlay onClick={handleOverlayClick}>
            <ZoomContainer onClick={(e) => e.stopPropagation()}>
                <TransformWrapper
                    ref={transformRef}
                    initialScale={1}
                    minScale={1}
                    maxScale={4}
                    centerOnInit={true}
                    centerZoomedOut={true}
                    onInit={(ref) => {
                        // Centrar inmediatamente al inicializar
                        setTimeout(() => {
                            ref.centerView();
                        }, 10);
                    }}
                    wheel={{ step: 0.2 }}
                    doubleClick={{ mode: 'reset' }}
                    pinch={{ step: 5 }}
                >
                    {({ zoomIn, zoomOut, resetTransform }) => (
                        <>
                            <ZoomControls>
                                <ZoomButton
                                    onClick={() => zoomIn()}
                                    aria-label="Acercar"
                                    title="Acercar (+)"
                                >
                                    +
                                </ZoomButton>
                                <ZoomButton
                                    onClick={() => zoomOut()}
                                    aria-label="Alejar"
                                    title="Alejar (-)"
                                >
                                    −
                                </ZoomButton>
                                <ZoomButton
                                    onClick={() => resetTransform()}
                                    aria-label="Restablecer zoom"
                                    title="Restablecer"
                                >
                                    ↺
                                </ZoomButton>
                            </ZoomControls>
                            <TransformComponent
                                wrapperClass="zoom-wrapper"
                                contentClass="zoom-content"
                            >
                                <ZoomImage
                                    src={src}
                                    alt={alt}
                                    draggable={false}
                                    onLoad={handleImageLoad}
                                    style={{
                                        opacity: imageLoaded ? 1 : 0,
                                        transition: 'opacity 0.2s ease'
                                    }}
                                />
                            </TransformComponent>
                            <ZoomInstructions>
                                Usa scroll o pinch para zoom • Arrastra para mover • Doble click para restablecer
                            </ZoomInstructions>
                        </>
                    )}
                </TransformWrapper>
                <CloseButton onClick={onClose} aria-label="Cerrar zoom">
                    ✕
                </CloseButton>
            </ZoomContainer>
        </ZoomOverlay>
    );

    if (!modalRoot) return null;

    return ReactDOM.createPortal(zoomContent, modalRoot);
};

export default ImageZoom;
